// Pacote prioritário — inadimplência/bloqueio/e-mail de acesso/comprovantes.
// Textos dinâmicos de atraso da mensalidade LOOTUS, compartilhados entre o
// alerta do Layout, o menu Financeiro e o modal de bloqueio. Regra
// definitiva: 1-14 dias de atraso = acesso normal + alerta; 15 dias OU MAIS
// = bloqueio (>=15, não >15). O backend (_saas_financial_block_evaluate)
// é sempre a fonte de verdade da decisão — este arquivo nunca decide nada,
// só formata o que o backend já calculou (dias_atraso/bloqueado).
export const FINANCIAL_BLOCK_GRACE_DAYS = 15;

export function diasAtrasoLabel(dias) {
  return dias === 1 ? "1 dia" : `${dias} dias`;
}

// Texto do alerta ANTES do bloqueio (1-14 dias de atraso). No 14º dia,
// avisa explicitamente que o bloqueio começa amanhã.
export function alertaVencidaTexto(dias) {
  if (dias === FINANCIAL_BLOCK_GRACE_DAYS - 1) {
    return `Sua mensalidade está vencida há ${diasAtrasoLabel(dias)}. Caso o pagamento não seja identificado, o acesso às demais funcionalidades do LOOTUS será temporariamente suspenso amanhã.`;
  }
  return `Sua mensalidade está vencida há ${diasAtrasoLabel(dias)}. Regularize o pagamento para evitar a suspensão temporária do acesso. Após ${FINANCIAL_BLOCK_GRACE_DAYS} dias de atraso, as demais funcionalidades do LOOTUS serão bloqueadas até a regularização.`;
}

// Corpo do modal de bloqueio (>=15 dias).
export function modalBloqueioCorpo(dias) {
  return `Identificamos uma mensalidade em atraso há ${diasAtrasoLabel(dias)}. Conforme as condições da assinatura do LOOTUS, o acesso às demais funcionalidades fica temporariamente suspenso após ${FINANCIAL_BLOCK_GRACE_DAYS} dias de atraso.\n\nVocê pode regularizar o pagamento diretamente nesta página.\n\nSe o pagamento já tiver sido realizado, envie o comprovante para que possamos verificar e agilizar a baixa.`;
}
